import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useLocation } from 'react-use';
import { getFromLocalStorage } from '../../../components/helper/authorizationHelper';
import { getAsync, postAsync, reactURL } from '../../../components/helper/axiosHelper';
import { updatedCart } from '../../../features/updatedCartSlice';
import { addToCart } from '../../../features/usercartSlice';
import { PageHitCountApi } from '../../../shared/Helper';
import LoadingAnimation from '../../../components/LoadingAnimation';
import LoaderModal from '../../../components/common/LoaderModal';
import Banners from '../../../components/elements/Banners';
import ModalCartSuccessful from '../../../components/elements/ModalCartSuccessfull';
import ProjectsCard from '../../../components/elements/ProjectsCard';
import SMSModal from '../../../components/elements/SMSModal';
import copy from 'copy-to-clipboard';

const Generaldonation = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [apiData, setApiData] = useState([]);
  const [paymentMethodId, setPaymentMethodId] = useState(1);
  const [amount, setAmount] = useState(0);
  const [isCart, setIsCart] = useState(false);
  const [value, setValue] = useState([]);
  const [modalMessageText, setModalMessageText] = useState('');
  const [modalExist, setModalExist] = useState(false);
  const [epUserID, setEpUserID] = useState(null);
  const [gridModalOpen, setGridModalOpen] = useState(false);
  const [projectGuID, setprojectGuID] = useState('');
  const [errorStates, setErrorStates] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [smsModal, setSmsModal] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [count, setCount] = useState(1);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [previousIndex, setPreviousIndex] = useState(currentIndex);
  const [projectId, setProjectId] = useState('');

  const token = localStorage.getItem('token');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    PageHitCountApi(pathname, 0);
    localStorage.setItem('isHome', true);
    getgeneraldata();
  }, []);

  const initializeErrorStates = () => {
    const initialErrors = apiData.map(() => false);
    setErrorStates(initialErrors);
  };

  useEffect(() => {
    if (apiData && apiData.length > 0) {
      setSelectedValues(Array(apiData.length).fill(1));
    }
  }, [apiData]);

  useEffect(() => {
    const retrievedData = getFromLocalStorage('upid');
    retrievedData
      ?.then((res) => {
        setEpUserID(res);
      })
      .catch((err) => {
        console.log('data', err);
      });
    initializeErrorStates();
  }, [apiData]);

  const getgeneraldata = async () => {
    await getAsync(`APIClient/InternalSHJCGeneralDonation?ModuleId=22`)
      .then((res) => {
        const result = res?.data;
        setApiData(result);
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const addCartItem = async (currentIndex, i, price, pId, projectTypeIdInt) => {
    try {
      // let selectedAmount = currentIndex !== i ? price : amount;
      let selectedAmount = currentIndex == i ? Number(amount) : 0;
      if (selectedAmount > 0) {
        if (selectedAmount !== 0) {
          setIsLoading(true);

          const res = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, { EPUserID: epUserID });
          setValue(res?.data);
          dispatch(addToCart(res?.data));

          const response = await postAsync(`APIClient/ProjectListGUID`, [
            { ProjectId: pId, ProjectTypeIdInt: projectTypeIdInt },
          ]);
          // if (response.statusCode) {
          //   setModalMessageText('Item not added in cart');
          //   setModalExist(true);
          //   setGridModalOpen(true);
          // }
          if (response) {
            setIsLoading(false);
          }
          const newItem = response?.data;
          const cartbody = {
            cartID: 0,
            projectName: newItem[0]?.projectName || newItem[0]?.titleAr,
            epUserID: epUserID,
            ip: 'string',
            projectID: newItem[0]?.id,
            amount: selectedAmount,
            PaymentPeriodID: +paymentMethodId,
            projectTypeIdInt,
          };
          if (token && value.length === 0 && res?.statusCode === 204) {
            await postAsync(`Cart/CreateCart`, cartbody);
            const resp = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, { EPUserID: epUserID });
            dispatch(addToCart(resp?.data));
            dispatch(updatedCart(true));
            setModalMessageText('Add to cart Successfully');
            setModalExist(false);
            setGridModalOpen(true);
            return;
          } else if (res.data?.length && res?.statusCode === 200) {
            const itemExistsdatabase = res?.data?.some((item) => item?.projectID === pId);
            if (token && !itemExistsdatabase) {
              await postAsync(`Cart/CreateCart`, cartbody);
              const respo = await postAsync(`Cart/GetCartListByEpUserIdAndIP`, { EPUserID: epUserID });
              dispatch(addToCart(respo?.data));
              dispatch(updatedCart(true));
              setModalMessageText('Add to cart Successfully');
              setAmount(0);
              setModalExist(false);
              setGridModalOpen(true);
            } else {
              setModalMessageText('Item  Already Exists');
              setModalExist(true);
              setGridModalOpen(true);
            }
          }

          if (!token) {
            const updateCart = (data) => {
              const updatedData = data.map((item) => {
                if (item.id === newItem[0].id) {
                  return { ...item, price: selectedAmount, paymentPeriodID: dataObject?.paymentMethodId };
                }
                return item;
              });
              localStorage.setItem('cart', JSON.stringify(updatedData));
            };
            // Retrieve existing cart data or create an empty array
            const existingData = JSON.parse(localStorage.getItem('cart')) || [];
            // Check if item exists and update price if needed
            const itemExists = existingData.some((item) => item.id === newItem[0].id);
            if (itemExists) {
              setIsCart(true);
              // toast.error('Item already exists.');
              setModalMessageText('Item  Already Exists');
              setModalExist(true);
              setGridModalOpen(true);
              updateCart(existingData);
            } else {
              setIsCart(true);
              dispatch(updatedCart(true));
              newItem[0].price = selectedAmount;
              updateCart([...existingData, ...newItem]);
              setModalMessageText('Add to cart Successfully');
              setAmount(0);
              setModalExist(false);
              setGridModalOpen(true);
            }
          }
        } else {
          setprojectGuID(pId);
        }
      } else {
        toast.error(`${t('Amount must be greater than 0')}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const dataObject = {
    paymentMethodId,
    amount,
    required: true,
  };

  const updateErrorState = (index, isError) => {
    setErrorStates((prevStates) => {
      const newErrorStates = [...prevStates];
      newErrorStates[index] = isError;
      return newErrorStates;
    });
  };

  const DonateHandle = (currentIndex, i, id, price, referralLink, isContribution, projectTypeIdInt) => {
    // let selectedAmount = currentIndex !== i ? price : amount;
    let selectedAmount = currentIndex == i ? Number(amount) : 0;

    if (selectedAmount > 0) {
      if (selectedAmount == 0) {
        updateErrorState(isContribution, true);
        return;
      } else {
        updateErrorState(isContribution, false);
        const payload = {
          ...dataObject,
          amount: selectedAmount,
          isContribution,
        };
        const link = `/externalPayment/${id}/${referralLink}/14/${projectTypeIdInt}`;
        navigate(link, { state: { paymentInfo: payload } });
      }
    } else {
      toast.error(`${t('Amount must be greater than 0')}`);
    }
  };
  const handleShareLink = (guid, projectTypeIdInt) => {
    const shareLink = `${reactURL}/PaymentProcess/` + guid + '/' + guid + '/' + 14 + '/' + projectTypeIdInt;
    copy(shareLink);
    toast.success(t('Link copy Successfully'));
  };

  const handleOnChange = (index, value) => {
    const newSelectedValues = [...selectedValues];
    newSelectedValues[index] = value;
    setSelectedValues(newSelectedValues);
    setPaymentMethodId(value);
  };

  return (
    <div className="">
      <Banners />
      <div className="container-fluid py-5 justify-center ">
        <div className="row px-4 sm:px-5 md:px-5 lg:px-5  justify-center">
          {apiData?.length > 0 ? (
            apiData?.map((data, index) => (
              <ProjectsCard
                key={index}
                i={index}
                data={data}
                handleOnChange={handleOnChange}
                handleShareLink={handleShareLink}
                addCartItem={addCartItem}
                DonateHandle={DonateHandle}
                previousIndex={previousIndex}
                setPreviousIndex={setPreviousIndex}
                setCurrentIndex={setCurrentIndex}
                setCount={setCount}
                setAmount={setAmount}
                amount={amount}
                count={count}
                currentIndex={currentIndex}
                errorStates={errorStates}
                isLoading={isLoading}
                selectedValues={selectedValues}
                setSmsModal={setSmsModal}
                setProjectId={setProjectId}
              />
            ))
          ) : (
            <LoadingAnimation />
          )}
          {
            <ModalCartSuccessful
              modalMessageText={modalMessageText}
              modalExist={modalExist}
              setGridModalOpen={setGridModalOpen}
              gridModalOpen={gridModalOpen}
            />
          }
          {<SMSModal smsModal={smsModal} setSmsModal={setSmsModal} projectId={projectId} />}
          {isLoading && <LoaderModal />}
        </div>
      </div>
    </div>
  );
};

export default Generaldonation;
